module.exports = __webpack_public_path__ + "img/member_02.db184479.png";